// extracted by mini-css-extract-plugin
module.exports = {"Menu":"bhf_a bht_h","Menu__offsetParent":"bhf_b bht_bj","Menu__trigger--shadowed":"bhf_c"};